import { LOCALE } from 'src/dataLayer/env'
import { LOCALE_TO_ZENDESK_MAPPING } from 'src/dataLayer/localData/languageCodes'

const ZENDESK_DEPARTMENTS = {
  de: 'German',
  en: 'English_US',
  en_GB: 'English_GB',
  es: 'Spanish',
  fr: 'French',
  it: 'Italian',
  pl: 'Polish',
  pt: 'Portuguese',
  sv: 'Swedish',
}

const ZENDESK_DEFAULT_LOCALE = 'en-gb'

const getZendeskLocale = () => LOCALE_TO_ZENDESK_MAPPING[LOCALE] || ZENDESK_DEFAULT_LOCALE

export { getZendeskLocale, ZENDESK_DEPARTMENTS }
